import request from '@/utils/request'

// 获取微信 JS-SDK 配置
export function getWechatJsConfig(url) {
  return request({
    url: '/wechat/jsconfig',
    method: 'get',
    params: { url }
  })
}
